import naja from 'naja';
naja.initialize();

Array.from(document.getElementsByClassName('g-recaptcha')).forEach(function(element){
    element.addEventListener('click', function(event){
        event.preventDefault();
        grecaptcha.ready(function() {
            grecaptcha.execute(element.getAttribute('data-site-key'), { action: 'submit'}).then(function(token) {
                const form = element.closest('form');
                const formData = new FormData(form);
                formData.append('g-recaptcha-response', token);
                naja.makeRequest('POST', form.action, formData);
            });
        });
    });
});